export default [
  {
    path: '/v2/payment/pre-invoices',
    name: 'pre-invoice-v2',
    meta: { requiresAuth: true, permission: 'view-pre-invoices' },
    component: () => import('./views/Index.vue')
  },
  {
    path: '/v2/payment/pre-invoices/create',
    name: 'pre-invoice-v2-create',
    meta: { requiresAuth: true, permission: 'create-pre-invoices' },
    component: () => import('./views/Create.vue')
  },
  {
    path: '/v2/payment/pre-invoices/:id/edit',
    name: 'pre-invoice-v2-edit',
    meta: { requiresAuth: true, permission: 'update-pre-invoices' },
    component: () => import('./views/Edit.vue')
  }
]
